import { RootState } from '../../Store';
import { useSelector } from 'react-redux';

const useIsFilterLoading = (): boolean => useSelector<RootState, boolean>(state => state.filter.loading);

export default useIsFilterLoading;
